module.exports = __webpack_public_path__ + "img/DBA.f5e2008c.png";